import React, { Component, useState } from "react";
import styles from "./css/WhyChooseComp.module.css";

const specs = [
  {
    title: "Trusted By Thousands",
    description: "We grow the most comprehensive network of professionals.",
    icon: "/assets/icons/why-choose-us/Trusted By Thousands.svg"
  },
  {
    title: "Wide Range Of Properties",
    description:
      "No job is too small! From residential homes to condo buildings, we take care of it all.",
      icon: "/assets/icons/why-choose-us/Wide Range Of Properties.svg"
  },
  {
    title: "Routine Maintenance",
    description:
      "Don't let the little projects become a major problem. Let us help you complete your 'To Do' list.",
      icon: "/assets/icons/why-choose-us/Routine Maintenance.svg"
  },
];

export class WhyChooseComp extends Component {
  render() {
    return (
      <div className={styles.whyChooseComp}>
        <div className={styles.whyChooseCompInner}>
          <div className={styles.headingCont}>
            <h2>Why Choose Us?</h2>
          </div>
          <div className={styles.specCont}>
            {specs.map((spec, index) => (
              <SpecBlocks key={index} spec={spec}></SpecBlocks>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

const SpecBlocks = (props) => {
  const [spec, setSpec] = useState(props.spec);
  return (
    <div className={styles.specBlock}>
      <div className={styles.specBlockInner}>
        <div className={styles.logoCont}>
          <img src={spec["icon"]} />
        </div>
        <div className={styles.title}>
          <p>{spec["title"]}</p>
        </div>
        <div className={styles.description}>
          <p>{spec["description"]}</p>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseComp;
